import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import "@/components/search-result/search-result.css"

// eslint-disable-next-line
declare let _paq: any

@customElement('sbk-search-result')
export class SbkSearchResult extends LitElement {

    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.track)
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.track)
    }

    track() {
        const headline = document.querySelector('sbk-headline-link')
        const text = headline?.innerHTML.trim()
        _paq.push(['trackEvent', 'Suche', 'SERP: ' + text])
    }

    createRenderRoot() {
        return this;
    }
}
